import { MedicalAidPickerComponent } from '../shared/components/medical-aid-picker/medical-aid-picker.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
// N7 — the facility selector's Hospital / In-rooms toggle, the same control the add dialog uses.
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule, Routes } from '@angular/router';
import { NgxColorsModule } from 'ngx-colors';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from './../core/guards/auth.guard';
import { stateModeGuard } from './../core/guards/state-mode.guard';
import { BetaViewComponent } from './components/beta-view/beta-view.component';
import { BillingAlertListComponent } from './components/billing-view/billing-alert-list/billing-alert-list.component';
import { BillingViewComponent } from './components/billing-view/billing-view.component';
import { IcdReviewWizardComponent } from './components/billing-view/icd-review-wizard/icd-review-wizard.component';
import { ByDateBillingListComponent } from './components/billing-view/by-date-billing-list/by-date-billing-list.component';
import { ByPatientBillingListComponent } from './components/billing-view/by-patient-billing-list/by-patient-billing-list.component';
import { InlineMasterBillingEditorComponent } from './components/billing-view/inline-master-billing-editor/inline-master-billing-editor.component';
import { PatientContainerComponent } from './components/patient-container/patient-container.component';
import { AdmitDetailsComponent } from './components/patient-file/admit-details/admit-details.component';
import { DischargeDetailsComponent } from './components/patient-file/discharge-details/discharge-details.component';
import { IcdCodeSelectorComponent } from './components/patient-file/icd-code-selector/icd-code-selector.component';
import { PatientAdmissionRecordDetailComponent } from './components/patient-file/patient-admission-record-detail/patient-admission-record-detail.component';
import { PatientAiRequestDetailComponent } from './components/patient-file/patient-ai-request-detail/patient-ai-request-detail.component';
import { PatientAiRequestListComponent } from './components/patient-file/patient-ai-request-list/patient-ai-request-list.component';
import { PatientAppointmentDetailComponent } from './components/patient-file/patient-appointment-detail/patient-appointment-detail.component';
import { PatientAppointmentListComponent } from './components/patient-file/patient-appointment-list/patient-appointment-list.component';
import { PatientBillingListComponent } from './components/patient-file/patient-billing-list/patient-billing-list.component';
import { PatientClinicalTimelineComponent } from './components/patient-file/patient-clinical-timeline/patient-clinical-timeline.component';
import { PatientCodingDetailComponent } from './components/patient-file/patient-coding-detail/patient-coding-detail.component';
import { PatientCommunicationListComponent } from './components/patient-file/patient-communication-list/patient-communication-list.component';
import { CommunicationViewDialogComponent } from './components/patient-file/patient-communication-list/communication-view-dialog.component';
import { PatientConsentDetailComponent } from './components/patient-file/patient-consent-detail/patient-consent-detail.component';
import { PatientConsentDialogComponent } from './components/patient-file/patient-consent-dialog/patient-consent-dialog.component';
import { PatientConsentListComponent } from './components/patient-file/patient-consent-list/patient-consent-list.component';
import { PatientDetailComponent } from './components/patient-file/patient-detail/patient-detail.component';
import { PatientFileComponent } from './components/patient-file/patient-file.component';
import { PatientFormListComponent } from './components/patient-file/patient-form-list/patient-form-list.component';
import { PatientFormSendDialogComponent } from './components/patient-file/patient-form-list/patient-form-send-dialog.component';
import { PatientDocumentListComponent } from './components/patient-file/patient-document-list/patient-document-list.component';
import { PatientDocumentSendDialogComponent } from './components/patient-file/patient-document-list/patient-document-send-dialog.component';
import { PatientMediaListComponent } from './components/patient-file/patient-media-list/patient-media-list.component';
import { PatientNoteDetailComponent } from './components/patient-file/patient-note-detail/patient-note-detail.component';
import { PatientSurveyResponsesComponent } from './components/patient-file/patient-survey-responses/patient-survey-responses.component';
import { PatientTaskDetailComponent } from './components/patient-file/patient-task-detail/patient-task-detail.component';
import { PatientTaskListComponent } from './components/patient-file/patient-task-list/patient-task-list.component';
import { PatientRiskDetailComponent } from './components/patient-file/patient-risk-detail/patient-risk-detail.component';
import { PatientRiskListComponent } from './components/patient-file/patient-risk-list/patient-risk-list.component';
import { PrescriptionDetailsComponent } from './components/patient-file/prescription-details/prescription-details.component';
import { PrescriptionListComponent } from './components/patient-file/prescription-list/prescription-list.component';
import { LogbookListComponent } from './components/patient-filters-list/logbook-list/logbook-list.component';
import { MorbidityMortalityListComponent } from './components/patient-filters-list/morbidity-mortality-list/morbidity-mortality-list.component';
import { PatientFiltersListItemComponent } from './components/patient-filters-list/patient-filters-list-item/patient-filters-list-item.component';
import { PatientFiltersListComponent } from './components/patient-filters-list/patient-filters-list.component';
import { RiskItemDetailDialogComponent } from './components/patient-filters-list/risk-management-list/risk-item-detail-dialog.component';
import { RiskManagementListComponent } from './components/patient-filters-list/risk-management-list/risk-management-list.component';
import { TagsListComponent } from './components/patient-filters-list/tags-list/tags-list.component';
import { TaskListComponent } from './components/patient-filters-list/task-list/task-list.component';
import { ResultsListComponent } from './components/results-list/results-list.component';
import { InboxComponent } from './components/inbox/inbox.component';
import { ConnectDashboardComponent } from './components/connect-dashboard/connect-dashboard.component';
import { InpatientListComponent } from './components/patient-list/inpatient-list/inpatient-list.component';
import { InviteListComponent } from './components/patient-list/invite-list/invite-list.component';
import { OutpatientListComponent } from './components/patient-list/outpatient-list/outpatient-list.component';
import { PatientListItemComponent } from './components/patient-list/patient-list-item/patient-list-item.component';
import { PatientListComponent } from './components/patient-list/patient-list.component';
import { EventDetailComponent } from './components/schedule-view/event-detail/event-detail.component';
import { EventScopeDialogComponent } from './components/schedule-view/event-scope-dialog/event-scope-dialog.component';
import { ScheduleCalendarComponent } from './components/schedule-view/schedule-calendar/schedule-calendar.component';
import { ScheduleListComponent } from './components/schedule-view/schedule-list/schedule-list.component';
import { ScheduleViewComponent } from './components/schedule-view/schedule-view.component';
import { TaskCalendarComponent } from './components/schedule-view/task-calendar/task-calendar.component';
import { ConsentWarningDialogComponent } from './components/schedule-view/consent-warning-dialog/consent-warning-dialog.component';
import { ExportDayAppointmentsDialogComponent } from './components/schedule-view/export-day-appointments-dialog/export-day-appointments-dialog.component';
import { OpenSlotsDialogComponent } from './components/schedule-view/open-slots-dialog/open-slots-dialog.component';
import { RescheduleConfirmDialogComponent } from './components/schedule-view/reschedule-confirm-dialog/reschedule-confirm-dialog.component';
import { ArchiveListComponent } from './components/patient-list/archive-list/archive-list.component';
import { DeceasedListComponent } from './components/patient-list/deceased-list/deceased-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InvoiceComponent } from './components/patient-file/patient-invoicing-list/patient-invoicing-list.component';
import { DisputeFormComponent } from './components/patient-file/dispute-form/dispute-form.component';
import { CapturePaymentComponent } from './components/patient-file/dispute-form/capture-payment/capture-payment.component';
import { RemoveInvoiceDialogComponent } from './components/patient-file/patient-invoicing-list/remove-invoice-dialog/remove-invoice-dialog.component';
import { MatTableModule } from '@angular/material/table';
import { MultilineItemsComponent } from './components/patient-file/dispute-form/multiline-items/multiline-items.component';
import { LinkPatientMedicalDetailsDialogComponent } from './components/patient-file/link-patient-medical-details-dialog/link-patient-medical-details-dialog.component';
import { IcdSuggestionsDialogComponent } from './components/patient-file/icd-suggestions-dialog/icd-suggestions-dialog.component';
import { PatientReferralDialogComponent } from './components/patient-file/patient-referral-dialog/patient-referral-dialog.component';
import { ReferralSummaryFilePickerComponent } from './components/patient-file/patient-referral-dialog/referral-summary-file-picker/referral-summary-file-picker.component';
import { ReferralNoteReviewDialogComponent } from './components/inbox/referral-note-review-dialog/referral-note-review-dialog.component';
import { ShareEntryDialogComponent } from './components/patient-file/share-entry-dialog/share-entry-dialog.component';
import { PatientAppShareDialogComponent } from './components/patient-file/patient-app-share-dialog/patient-app-share-dialog.component';
import { ReferralIncomingDialogComponent } from './components/inbox/referral-incoming-dialog/referral-incoming-dialog.component';
import { ReferralPracticeEntryDialogComponent } from './components/inbox/referral-practice-entry-dialog/referral-practice-entry-dialog.component';
import { ReferralOnwardNoticeDialogComponent } from './components/inbox/referral-onward-notice-dialog/referral-onward-notice-dialog.component';
import { ReferralLinkRequestDialogComponent } from './components/inbox/referral-link-request-dialog/referral-link-request-dialog.component';
import { TaskInboxDialogComponent } from './components/inbox/task-inbox-dialog/task-inbox-dialog.component';
import { ReferralDemographicsDialogComponent } from './components/inbox/referral-demographics-dialog/referral-demographics-dialog.component';
import { PatientAppHistoryDialogComponent } from './components/inbox/patient-app-history-dialog/patient-app-history-dialog.component';
import { ClinicalSummaryDialogComponent } from './components/patient-file/clinical-summary-dialog/clinical-summary-dialog.component';
import { IcdArchivedCodesDialogComponent } from './components/patient-file/icd-archived-codes-dialog/icd-archived-codes-dialog.component';
import { IcdCodeDateDialogComponent } from './components/patient-file/icd-code-date-dialog/icd-code-date-dialog.component';
import { IcdCodeEditDialogComponent } from './components/patient-file/icd-code-edit-dialog/icd-code-edit-dialog.component';
import { MedicalStatementDialogComponent } from './components/patient-file/medical-statement-dialog/medical-statement-dialog.component';
import { FileAlertListComponent } from './components/patient-list/file-alert-list/file-alert-list.component';
import { DuplicateAlertListComponent } from './components/patient-list/duplicate-alert-list/duplicate-alert-list.component';
import { DuplicateAlertListItemComponent } from './components/patient-list/duplicate-alert-list-item/duplicate-alert-list-item.component';
import { PatientMorbidityMortalityDetailComponent } from './components/patient-file/patient-morbidity-mortality-detail/patient-morbidity-mortality-detail.component';
import { PatientLabOrderDetailComponent } from './components/patient-file/patient-lab-order-detail/patient-lab-order-detail.component';
import { LabOrdersListComponent } from './components/patient-file/lab-orders-list/lab-orders-list.component';
import { RenderMoreDirective } from '../shared/directives/render-more.directive';

const routes: Routes = [
  {
    path: '',
    component: PatientContainerComponent,
    children: [
      {
        path: 'list',
        component: PatientListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'schedule',
        component: ScheduleViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'filters',
        component: PatientFiltersListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'results',
        component: ResultsListComponent,
        canActivate: [AuthGuard],
      },
      /*
       * The Inbox — `tasks/inbox.md`. A sibling of `results`, in the PRIMARY outlet, so it draws
       * in `PatientContainerComponent`'s left pane exactly as the other list pages do.
       *
       * It must stay above the `outlet: 'patient'` entries below: those are matched by outlet
       * rather than by path, and grouping the primary-outlet pages together is what keeps that
       * readable.
       */
      {
        path: 'inbox',
        component: InboxComponent,
        canActivate: [AuthGuard],
      },
      // The practice's MedicAI Connect dashboard: the Connect item in the sidebar, for groups on Connect.
      {
        path: 'connect',
        component: ConnectDashboardComponent,
        canActivate: [AuthGuard, stateModeGuard],
      },
      {
        path: 'coding',
        component: BillingViewComponent,
        canActivate: [AuthGuard, stateModeGuard],
      },
      {
        path: 'beta',
        component: BetaViewComponent,
        canActivate: [AuthGuard, stateModeGuard],
      },
      {
        path: 'statistics',
        loadChildren: () => import('../statistics/statistics.module').then(m => m.StatisticsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'file/:id',
        component: PatientFileComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'add',
        component: PatientDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'edit/:id',
        component: PatientDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'admit/:id',
        component: AdmitDetailsComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'discharge/:id',
        component: DischargeDetailsComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'add-note',
        component: PatientNoteDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'edit-note/:id',
        component: PatientNoteDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'add-mm',
        component: PatientMorbidityMortalityDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'edit-mm/:id',
        component: PatientMorbidityMortalityDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'edit-admission-record/:id',
        component: PatientAdmissionRecordDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'add-appointment',
        component: PatientAppointmentDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'edit-appointment/:id',
        component: PatientAppointmentDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'add-event',
        component: EventDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'edit-event/:id',
        component: EventDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'add-task',
        component: PatientTaskDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'edit-task/:id',
        component: PatientTaskDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      // N2 — the routed risk-item detail, deliberately placed beside the task pair it copies.
      // `edit-risk-item/:id` is fed by `PatientRiskItemService.editingRiskItem$`, which the caller
      // sets BEFORE navigating, exactly as `task-list.loadTask` does above.
      {
        path: 'add-risk-item',
        component: PatientRiskDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'edit-risk-item/:id',
        component: PatientRiskDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'add-procedure-code',
        component: PatientCodingDetailComponent,
        canActivate: [AuthGuard, stateModeGuard],
        outlet: 'patient'
      },
      {
        path: 'edit-procedure-code/:date',
        component: PatientCodingDetailComponent,
        canActivate: [AuthGuard, stateModeGuard],
        outlet: 'patient'
      },
      {
        path: 'add-consent',
        component: PatientConsentDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'edit-consent/:id',
        component: PatientConsentDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'edit-request/:id',
        component: PatientAiRequestDetailComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'add-prescription',
        component: PrescriptionDetailsComponent,
        canActivate: [AuthGuard],
        outlet: 'patient'
      },
      {
        path: 'add-invoicing',
        component: DisputeFormComponent,
        canActivate: [AuthGuard, stateModeGuard],
        outlet: 'patient'
      },
      {
        path: 'add-lab-order',
        component: PatientLabOrderDetailComponent,
        canActivate: [AuthGuard, stateModeGuard],
        outlet: 'patient'
      },
      {
        path: 'edit-lab-order/:id',
        component: PatientLabOrderDetailComponent,
        canActivate: [AuthGuard, stateModeGuard],
        outlet: 'patient'
      },
      {
        path: '',
        redirectTo: 'schedule',
        pathMatch: 'full'
      }
    ]
  },

];

const MAT_MODULES = [
  MatButtonModule,
  MatCheckboxModule,
  MatFormFieldModule,
  MatSelectModule,
  MatCheckboxModule,
  MatRadioModule,
  MatInputModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatCardModule,
  MatListModule,
  MatExpansionModule,
  MatTabsModule,
  MatDatepickerModule,
  MatMenuModule,
  MatDividerModule,
  MatTooltipModule,
  MatDialogModule,
  MatToolbarModule,
  MatChipsModule,
  MatAutocompleteModule,
  MatTableModule,
  DragDropModule,
]

@NgModule({
  declarations: [
    PatientListComponent,
    PatientDetailComponent,
    PatientFileComponent,
    PatientContainerComponent,
    ScheduleViewComponent,
    InpatientListComponent,
    OutpatientListComponent,
    PatientListItemComponent,
    PatientConsentListComponent,
    PatientFormListComponent,
    PatientFormSendDialogComponent,
    // Practice documents (tasks/practice-documents.md 7 phase 2). Visible, unlike the two
    // above: the Forms tab beside it stays hidden, documents ship.
    PatientDocumentListComponent,
    PatientDocumentSendDialogComponent,
    PatientAppointmentListComponent,
    PatientClinicalTimelineComponent,
    PatientNoteDetailComponent,
    PatientAppointmentDetailComponent,
    ScheduleCalendarComponent,
    ScheduleListComponent,
    ConsentWarningDialogComponent,
    ExportDayAppointmentsDialogComponent,
    OpenSlotsDialogComponent,
    RescheduleConfirmDialogComponent,
    IcdCodeSelectorComponent,
    InviteListComponent,
    PatientFiltersListComponent,
    TagsListComponent,
    PatientFiltersListItemComponent,
    LogbookListComponent,
    MorbidityMortalityListComponent,
    TaskListComponent,
    RiskManagementListComponent,
    RiskItemDetailDialogComponent,
    ResultsListComponent,
    InboxComponent,
    BillingViewComponent,
    IcdReviewWizardComponent,
    ByDateBillingListComponent,
    ByPatientBillingListComponent,
    InlineMasterBillingEditorComponent,
    AdmitDetailsComponent,
    DischargeDetailsComponent,
    PatientConsentDetailComponent,
    PatientConsentDialogComponent,
    PatientAiRequestListComponent,
    PatientAiRequestDetailComponent,
    PatientTaskListComponent,
    PatientRiskListComponent,
    PatientRiskDetailComponent,
    PatientBillingListComponent,
    PatientCommunicationListComponent,
    CommunicationViewDialogComponent,
    PatientMediaListComponent,
    PatientTaskDetailComponent,
    PatientCodingDetailComponent,
    BetaViewComponent,
    BillingAlertListComponent,
    PatientAdmissionRecordDetailComponent,
    EventDetailComponent,
    EventScopeDialogComponent,
    TaskCalendarComponent,
    PrescriptionListComponent,
    PrescriptionDetailsComponent,
    ArchiveListComponent,
    DeceasedListComponent,
    InvoiceComponent,
    DisputeFormComponent,
    MultilineItemsComponent,
    LinkPatientMedicalDetailsDialogComponent,
    IcdSuggestionsDialogComponent,
    PatientReferralDialogComponent,
    ReferralSummaryFilePickerComponent,
    ReferralNoteReviewDialogComponent,
    ShareEntryDialogComponent,
    PatientAppShareDialogComponent,
    ReferralIncomingDialogComponent,
    ReferralPracticeEntryDialogComponent,
    ReferralOnwardNoticeDialogComponent,
    ReferralLinkRequestDialogComponent,
    TaskInboxDialogComponent,
    ReferralDemographicsDialogComponent,
    PatientAppHistoryDialogComponent,
    ClinicalSummaryDialogComponent,
    IcdArchivedCodesDialogComponent,
    IcdCodeDateDialogComponent,
    IcdCodeEditDialogComponent,
    MedicalStatementDialogComponent,
    MedicalStatementDialogComponent,
    CapturePaymentComponent,
    RemoveInvoiceDialogComponent,
    PatientSurveyResponsesComponent,
    FileAlertListComponent,
    DuplicateAlertListComponent,
    DuplicateAlertListItemComponent,
    PatientMorbidityMortalityDetailComponent,
    PatientLabOrderDetailComponent,
    LabOrdersListComponent,
  ],
  imports: [
    CommonModule,
    RenderMoreDirective,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MedicalAidPickerComponent,
    NgxColorsModule,
    ScrollingModule,
    ...MAT_MODULES
  ],
  exports: [
    PatientContainerComponent
  ],
  providers: [
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  ]
})
export class PatientModule { }
